import React from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';
// import _ from 'lodash';
import PropTypes from 'prop-types';

const barDefault = {
  xAxisProps: {
    dataKey: 'name',
    textAnchor: 'end',
    verticalAnchor: 'end',
    scaleToFit: false,
    interval: 0,
    fontSize: '10px',
    // scale: 'auto',
  },
  yAxisProps: {
    fontSize: '10px',
  },
};

// const data = [
//   {
//     name: 'Jan',
//     2019: 4000,
//     2020: 2400,
//   },
//   {
//     name: 'Feb',
//     2019: 3000,
//     2020: 1398,
//   },
//   {
//     name: 'Mar',
//     2019: 2000,
//     2020: 9800,
//   },
//   {
//     name: 'Apr',
//     2019: 2780,
//     2020: 3908,
//   },
//   {
//     name: 'May',
//     2019: 1890,
//     2020: 4800,
//   },
//   {
//     name: 'Jun',
//     2019: 2390,
//     2020: 3800,
//   },
//   {
//     name: 'Jul',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Aug',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Sep',
//     2019: 3490,
//     2020: 2000,
//   },
//   {
//     name: 'Oct',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Nov',
//     2019: 3490,
//     2020: 4300,
//   },
//   {
//     name: 'Dec',
//     2019: 3490,
//     2020: 4300,
//   },
// ];

function BplsChartComponent({
  chartData,
}) {
  return (
    <ResponsiveContainer width="100%" height={400} minWidth="100%">
      <AreaChart
        data={chartData}
        margin={{
          top: 10,
          right: 30,
          left: 0,
          bottom: 0,
        }}
      >
        <defs>
          <linearGradient id="color1" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#5272AA" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#5272AA" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color2" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#A3B3F9" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#A3B3F9" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color3" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#8EEED7" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#8EEED7" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="color4" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="#87A1D1" stopOpacity={0.8} />
            <stop offset="95%" stopColor="#87A1D1" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid height={1} y={0} />
        <XAxis {...barDefault.xAxisProps} dataKey="name" />
        <YAxis axisLine={false} tick={false} />
        <Tooltip />
        {/* NEW */}
        <Area
          type="monotone"
          dataKey="NEW"
          stackId="1"
          stroke="#5272AA"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color1)"
        />
        {/* RENEWAL */}
        <Area
          type="monotone"
          dataKey="RENEWAL"
          stackId="2"
          stroke="#A3B3F9"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color2)"
        />
        {/* QUARTERLY */}
        <Area
          type="monotone"
          dataKey="QUARTERLY"
          stackId="3"
          stroke="#8EEED7"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color3)"
        />
        {/* DELIQUENT */}
        <Area
          type="monotone"
          dataKey="DELINQUENT"
          stackId="4"
          stroke="#87A1D1"
          strokeWidth={2}
          fillOpacity={1}
          fill="url(#color4)"
        />
      </AreaChart>
    </ResponsiveContainer>
  );
}

BplsChartComponent.propTypes = {
  chartData: PropTypes.instanceOf(Array).isRequired,
};

export default BplsChartComponent;
